<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Expense</p>
                <form @submit.prevent="submitForm" enctype="multipart/form-data">
                    <div class="grid grid-cols-8 gap-4 mb-8">
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Title'"/>
                            <breeze-input class="w-full" v-model="form.title"/>
                            <breeze-input-error :message="form.errors?form.errors.title:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <FormMultiselect
                                label="Expense Type"
                                :options="expense_types"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.expense_type"
                                placeholder="Select "
                                :error="form.errors.expense_type"
                            />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Amount'"/>
                            <breeze-input type="number" class="w-full" v-model="form.amount"/>
                            <breeze-input-error :message="form.errors?form.errors.amount:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Date'"/>
                            <breeze-input type="date" class="w-full" v-model="form.month"/>
                            <breeze-input-error :message="form.errors?form.errors.month:''"/>
                        </div>

                        <div class="col-span-full">
                            <breeze-label :value="'Note'"/>
                            <textarea
                                rows="5"
                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border border-gray-300 rounded-md px-4 py-2 w-full"
                                v-model="form.note"/>
                            <breeze-input-error :message="form.errors?form.errors.note:''"/>
                        </div>
                    </div>
                    <button-link :href="route('internal.expense.list',branchid)"
                                 class="bg-red-500 mr-4 hover:bg-red-400">Cancel
                    </button-link>
                    <breeze-button :disabled="form.processing">Submit</breeze-button>
                    <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Expense Updated!</span>
                    <exception/>
                </form>
            </div>
        </div>
    </internal>
</template>

<script>
import Internal from '@/Pages/Internal/Internal'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import ButtonLink from '@/Components/ButtonLink'
import CardHeader from '@/Components/CardHeader'
import {useForm} from '@inertiajs/inertia-vue3'
import BreezeInputError from '@/Components/InputError'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import Loading from '@/Components/Loading'
import SelectList from '@/Components/SelectList'
import Exception from '@/Components/Exception'
import BreezeTable from '@/Components/Table'
import {VueEditor} from "vue3-editor";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

export default {
    components: {
        FormMultiselect,
        Internal,
        BreezeInput,
        BreezeLabel,
        ButtonLink,
        CardHeader,
        BreezeInputError,
        BreezeButton,
        BreezeCheckbox,
        Loading,
        Exception,
        BreezeTable,
        SelectList,
        VueEditor
    },
    props: ['expense_types', 'expense'],
    data() {
        return {
            form: useForm({
                '_method': 'PUT',
                title: this.expense.title,
                amount: this.expense.amount,
                expense_type: this.expense.type,
                month: this.expense.month,
                note: this.expense?.note,
            }),
            branchid: localStorage.branchId,
        }
    },
    methods: {
        submitForm() {
            // this.form.photo = this.$refs.photo.files[0];
            this.form.post(route('internal.expense.update', [this.branchid, this.expense.id]));
        }
    },
}
</script>
<style>
#editor {
    height: 400px;
}
</style>
